import geoAPI from "../../../api/geoAPI";
import { urlContexts } from "../../../constants";

export const getPointOfAttention = async (tenantid: string) => {
  const { data } = await geoAPI.get(
    `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
      (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
      }/iuvibanking-point-service-api/rest/1.0/service-point`,
    {
      headers: {
        tenant: tenantid
      }
    }
  );  
  return data;
};

export const createPointOfAttention = async (body: any, tenantid: string, appId: string) => {
    const withDueDate: boolean = (body.startDate !== '' && body.endDate !== '')
    let pointsData:any = {
      name: body.name,
      code: body.code,
      address: body.address,
      observation: body.observation,
      phone: body.phone,
      latitude: body.latitude,
      longitude: body.longitude,
      recordType: withDueDate ? 'WITH_DUE_DATE' : 'WITHOUT_DUE_DATE',
      appId,
      pointServiceTypeId: body.pointServiceType,
      statusId: 1,
      countryId: body.country,
      stateId: body.department,
      cityId: body.city,
      serviceIds: body.serviceIds,
      scheduleIds: body.scheduleIds,
    }

    pointsData = (body.file !== '') ? {...pointsData, file: body.file} : pointsData;
    pointsData = withDueDate ? {...pointsData, startDate: body.startDate, endDate: body.endDate} : pointsData;

    const { data } = await geoAPI.post(
          `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
          }/iuvibanking-point-service-api/rest/1.0/service-point`,
          pointsData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              tenant: tenantid
            }
          }
        );
  
    return data;
};

export const updatePointOfAttention = async (body: any, tenantid: string, appId: string) => {
  const withDueDate: boolean = (body.startDate !== '' && body.endDate !== '')
  let pointsData:any = {
    name: body.name,
    code: body.code,
    address: body.address,
    observation: body.observation,
    phone: body.phone,
    latitude: body.latitude,
    longitude: body.longitude,
    recordType: withDueDate ? 'WITH_DUE_DATE' : 'WITHOUT_DUE_DATE',
    appId,
    pointServiceTypeId: body.pointServiceType,
    statusId: 1,
    countryId: body.country,
    stateId: body.department,
    cityId: body.city,
    serviceIds: body.serviceIds,
    scheduleIds: body.scheduleIds,
  }

  pointsData = (body.file !== '') ? {...pointsData, file: body.file} : pointsData;
  pointsData = withDueDate ? {...pointsData, startDate: body.startDate, endDate: body.endDate} : pointsData;

  const { data } = await geoAPI.put(
        `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
          }/iuvibanking-point-service-api/rest/1.0/service-point/${body.id}`,
        pointsData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            tenant: tenantid
          }
        }
      );

  return data;
};

export const deletePointOfAttention = async (id: any, tenantid: string) => {
  const { data } = await geoAPI.delete(
    `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
      }/iuvibanking-point-service-api/rest/1.0/service-point/${id}`,
    {
      headers: {
        tenant: tenantid
      }
    }
  );
  return data;
};

export const getPointOfAttentionSearch = async (params: any, tenantid: string, appid: string) => {
  const { data } = await geoAPI.get(
        `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
          }/iuvibanking-point-service-api/rest/1.0/service-point`,
        {
          headers: {
            tenant: tenantid
          },
          params: {
            ...params,
            appId: appid
          }
        }
      );
  return data;
};

export const updateMultiplePointOfAttention = async (body: any, tenantid: string, appId: string) => {
  let pointsData:any = {
    observation: body.observation,
    serviceIds: body.serviceIds,
    scheduleIds: body.scheduleIds,
    ids: body.ids
  }

  pointsData = (body.file !== '') ? {...pointsData, file: body.file} : pointsData;

  const { data } = await geoAPI.patch(
        `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
          }/iuvibanking-point-service-api/rest/1.0/service-point`,
        pointsData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            tenant: tenantid
          }
        }
      );

  return data;
};